
export const ROUTES = {
    ROOT: {
        url: "/"
    },
    UNSUBSCRIBE_NOTIFICATION: {
        url: "/unsubscribe-notification"
    },
    LOGIN: {
        url: "/login",
        subRoutes: {
            RESET_PASSWORD: {
                url: "/login/reset-password"
            },
        },
    },
    DASHBOARD: {
        url: "/dashboard"
    },
    FEATURE: {
        url: "/feature"
    },
    SUPPORT: {
        url: "/support",
        subRoutes: {
            SERVICE_REQUESTS: {
                url: "/support/service-requests",
                subRoutes: {
                    CREATE: {
                        url: "/support/service-requests/create"
                    },
                    UPDATE: {
                        url: "/support/service-requests/update"
                    }
                }
            },
            CUSTOMERS: {
                url: "/support/customers",
                subRoutes: {
                    ACCOUNTS: {
                        url: "/support/customers/accounts",
                    },
                }
            },
            INSTITUTIONS: {
                url: "/support/institutions"
            },
            NOTIFICATIONS: {
                url: "/support/notifications"
            },
            SITES: {
                url: "/support/sites"
            }
        }
    },
    LEGACY_EXPERIENCE: {
        url: "/classic"
    },
    PRODUCTS: {
        url: "/products"
    },
    ANALYTICS: {
        url: "/analytics"
    },
    QUESTIONS: {
        url: "https://solutions.yodlee.com/YCC-Acknowledgement-Page.html"
    },
    SETTINGS: {
        url: "/settings",
        subRoutes: {
            PERMISSIONS: {
                url: "/settings/permissions"
            },
            SYSTEM_SETTINGS: {
                url: "/settings/system-settings"
            },
            MANAGE_INSIGHTS_USER: {
                url: "/settings/insights-users"
            }
        }
    },
    INTERNAL_TOOLS: {
        url: "/internal-tools",
        subRoutes: {
            YODLEE_CUSTOMERS: {
                url: "/internal-tools/yodlee-customers"
            },
            ONBOARDING: {
                url: "/internal-tools/onboarding"
            },
            NOTIFICATIONS: {
                url: "/internal-tools/notifications"
            },
            MERCHANT_METADATA: {
                url: "/internal-tools/merchant-metadata"
            },
            SITE_METADATA: {
                url: "/internal-tools/site-metadata"
            },
            ASK_YODLEE_ADMIN_PORTAL: {
                url: "/internal-tools/ask-yodlee-admin-portal"
            }
        }
    },
    TRIALS: {
        url: "/trails",
        subRoutes: {
            CREDIT_ACCELARATOR: {
                url: "/trails/credit-matrix"
            },
            CONSUMER_INSIGHTS: {
                url: "/trails/consumer_insights"
            },
            VERIFICATION: {
                url: "/trails/verification"
            },
            PFM: {
                url: "/trails/pfm"
            },
            SMB: {
                url: "/trails/smb"
            },
            ATV: {
                url: "/trails/atv"
            },
            ADVISOR_INSIGHTS: {
                url: "/trails/advisor-insights"
            }
        }
    },
    IEB: {
        url: "/ieb",
        subRoutes: {
            SEGMENTATION: {
                url: "/ieb/segmentation"
            },
            PRODUCT_INSIGHTS: {
                url: "/ieb/product-insights"
            },
            INSIGHTS_DASHBOARD: {
                url: "/ieb/insights-dashboard"
            }
        }
    },
    MANAGEMENT_REPORTING: {
        url: "/product-health-reporting",
        subRoutes: {
            FASTLINK_JOURNEY_ANALYTICS: {
                url: "/product-health-reporting/fastlink-journey-analytics"
            },
            AGGREGATION: {
                url: "/product-health-reporting/aggregation"
            },
            VERIFICATION: {
                url: "/product-health-reporting/verification"
            }
        }
    },
    DEVELOPER_CHAT: {
        url: "/developer-chat"
    },
    MY_ACCOUNT: {
        url: "/my-account",
        subRoutes: {
            SIGN_OUT: {
                url: "/my-account/logout"
            }
        }
    },
    SPLASH: {
        url: "/splash"
    },
    STATUS: {
        url: "/status"
    },
    CA_WEBFORM: {
        url: "/credit-inquiry-form"
    },
}

export const API_URLS = {
    HEALTH: (url: string) => `${url}/health`,
    ONLOAD: `${process.env.REACT_APP_API_ROOT_URL}/onload`,
    USER_FEATURES: (userId: number) => `${process.env.REACT_APP_API_ROOT_URL}/feature/user/${userId}`,
    USER_PERMISSION: (userId: number) => `${process.env.REACT_APP_API_ROOT_URL}/user/${userId}/permission`,
    INSIGHT_USERS:  `${process.env.REACT_APP_API_ROOT_URL}/insights/user`,
    LOGO: `${process.env.REACT_APP_API_ROOT_URL}/setting/logo`,
    BANNER: `${process.env.REACT_APP_API_ROOT_URL}/setting/banner`,
    KEEP_ALIVE: `${process.env.REACT_APP_API_ROOT_URL}/keep-alive`,
    PICTURE: (userId: number) => `${process.env.REACT_APP_API_ROOT_URL}/user/${userId}/picture`,
    PREFERENCE: `${process.env.REACT_APP_API_ROOT_URL}/user/preference`, //need to append appId as queryParams
    AMPLITUDE_STATUS: `${process.env.REACT_APP_API_ROOT_URL}/amplitude/status`,
    SSO_INFO_URL: `${process.env.REACT_APP_API_ROOT_URL}/data-center/sso-info`,
    AUTH_TOKEN: `${process.env.REACT_APP_API_ROOT_URL}/token`,
    OPEN_BANKING_STATUS: `${process.env.REACT_APP_API_ROOT_URL}/openbanking/status`,
    REFRESH_CACHED_DATA: `${process.env.REACT_APP_API_ROOT_URL}/reload`,
    CA_WEBFORM_INIT: `${process.env.REACT_APP_API_ROOT_URL}/webform/init`,
    BRAND_PRODUCTS: `${process.env.REACT_APP_API_ROOT_URL}/brand/products`,
    UNSUBSCRIBE_NOTIFICATION_GENERATE: `${process.env.REACT_APP_API_ROOT_URL}/unsubscribe-notification/otp/generate`,
    UNSUBSCRIBE_NOTIFICATION_VERIFY: `${process.env.REACT_APP_API_ROOT_URL}/unsubscribe-notification/otp/verify`,
    TAG: `${process.env.REACT_APP_API_ROOT_URL}/tag`
}

export const BROWSER_DOWNLOAD_URLS = {
    firefox: "https://www.mozilla.org/en-US/firefox/new/",
    chrome: "https://www.google.com/intl/en/chrome/browser/desktop/",
    iexplorer: "https://www.microsoft.com/en-us/download/internet-explorer.aspx",
    edge: "https://www.microsoft.com/en-us/windows/microsoft-edge",
    safari: "https://support.apple.com/en-us/HT204416",
    opera: "https://www.opera.com/"
}
